module.exports = __webpack_public_path__ + "static/media/24.0eb8686d.jpg";